import { observer } from 'mobx-react';
import * as React from 'react';
import { L, NotTranslated, T } from '../../../Translations';
import { EventDetails } from '../../Freebusy/Types';
import * as style from '../FreebusyCoachingAd/style.module.css';

interface Props {
  eventDetails: EventDetails;
}

const MeetingDetails: React.FC<Props> = ({ eventDetails }) => (
  <div className={style.meetingDetails}>
    <dl>
      <dt>
        <T kind="Title" />:
      </dt>{' '}
      <dd>
        <NotTranslated text={eventDetails.title} />
      </dd>
    </dl>
    <dl>
      <dt>
        <T kind="Time" />:
      </dt>
      <dd>
        <L localizeable={eventDetails.date} format={'time-of-day'} />
      </dd>
    </dl>
    <dl>
      <dt>
        <T kind="Date" />:
      </dt>
      <dd>
        <L localizeable={eventDetails.date} format={'short-month-day-year'} />
      </dd>
    </dl>
    <p>
      <T kind="Please view the invite sent to your calendar for full details" />
    </p>
  </div>
);

export default observer(MeetingDetails);
